module.exports = __webpack_public_path__ + "static/Portfolio01-1a97cffebc788ae814789026d69297be.jpg";